import React from 'react'
import { XP_REQUEST_MODE } from '@enonic/react-components'

// The `xp/` tree is outside the prototype's Tailwind source scan, so no class written here
// ever gets a rule — none of the repo's `*--empty` classes has one. Inline styles are the
// only way to give an empty part a box the editor can actually see and click. Copy is
// hardcoded English: nothing under `react4xp/components/**` localises, and the mode gate
// below keeps it off preview and live.
const PLACEHOLDER_STYLE: React.CSSProperties = {
	boxSizing: 'border-box',
	minHeight: '96px',
	padding: '16px',
	border: '1px dashed #9ca3af',
	borderRadius: '4px',
	color: '#4b5563',
	font: '14px/1.5 system-ui, sans-serif',
}

export type EditorPlaceholderProps = {
	mode?: string
	componentClass: string
	title: string
	reason: string
	heading?: string
}

export const EditorPlaceholder = ({ mode, componentClass, title, reason, heading }: EditorPlaceholderProps) => {
	if (mode !== XP_REQUEST_MODE.EDIT) {
		return <></>
	}

	return (
		<section className={`${componentClass} ${componentClass}--empty`} style={PLACEHOLDER_STYLE}>
			<strong>
				{title}
				{heading ? `: ${heading}` : ''}
			</strong>
			<div>{reason}</div>
		</section>
	)
}
